/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Event_Entity_Sales_QuotesInputs */



/**
* | output |
* | --- |
* | "Sales quotes" |
*
* @param {Agent_Event_Entity_Sales_QuotesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_event_entity_sales_quotes = /** @type {((inputs?: Agent_Event_Entity_Sales_QuotesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Event_Entity_Sales_QuotesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verkaufsangebote")
	return /** @type {LocalizedString} */ ("Sales quotes")
});